import request from '@/util/request'
import {
  JSON_CONFIG,
  getAPILangParam
} from '@/util/helper.js'

export function sendConfirmCode (lineId, phone) {
  return request({
    url: `/caregiver/${lineId}/signup/mobile`,
    method: 'post',
    header: JSON_CONFIG,
    data: {
      phone
    }
  })
}

export function verifyPassCode (lineId, requestBody) {
  return request({
    url: `/caregiver/${lineId}/signup/verify`,
    method: 'post',
    header: JSON_CONFIG,
    data: requestBody
  })
}

export function getPatientList (lineId) {
  return request({
    url: `/caregiver/${lineId}/patient`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function getDaily (lineId, pid, startDate, endDate) {
  return request({
    url: `/caregiver/${lineId}/record/week`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      pid: pid,
      sDate: startDate,
      eDate: endDate
    }
  })
}

export function getActivity (lineId, patientId, startDate, endDate) {
  return request({
    url: `/caregiver/${lineId}/record/active`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      pid: patientId,
      sDate: startDate,
      eDate: endDate
    }
  })
}

export function getAchieved (lineId, patientId, startDate, endDate) {
  return request({
    url: `/caregiver/${lineId}/record/averageAchieved`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      pid: patientId,
      sDate: startDate,
      eDate: endDate
    }
  })
}

export function getRecordOfDate (lineId, patientId, date) {
  return request({
    url: `/caregiver/${lineId}/record/${date}`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      pid: patientId,
      lang: getAPILangParam()
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/caregiver.js